import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorManagerService } from './error-manager.service';
import { MessageTitle, UserStatus } from '../enums/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    public router: Router,
    private userService: UserService,
    private matDialog: MatDialog,
    private errorManager: ErrorManagerService,
  ) {}

  hasSomeSuspention(user): boolean {
    const suspenableStatuses = [ UserStatus.TERMINATED, UserStatus.DEATH_CONFIRMED, UserStatus.CANCELED, UserStatus.TRANSITIONED, UserStatus.LOCKED_INVALID_TFA, UserStatus.SUSPENDED_ADMIN ];

    if(suspenableStatuses.includes(user.status)) {
      return true;
    }

    let suspentionsCount = 0;
    if (user.suspended_by_payment) {
      suspentionsCount++;
      localStorage.setItem('suspended_by_payment', user.suspended_by_payment);
    }

    return suspentionsCount > 0;
  }

  requestLastTerms() {
    return this.http.post<any>(`/api/terms/get`, '').toPromise();
  }

  async getLastTermsId() {
    
  }

  async navigateUserToRightScreen() {
    const user = this.userService.user;
    if (user) {
      let termsId;
      await this.requestLastTerms().then((res) => {
        termsId = res.data[0].id;
      });
      if (!user.termsAccepted || user.termsId < termsId) {
        this.router.navigate(['/terms']);
      } else {
        if(this.hasSomeSuspention(user)) {
          this.router.navigate(['/signin'], { queryParams: { suspended: true } });
        } else if(user.status === UserStatus.STARTED_PAYMENT) {
          this.router.navigate(['/checkout']);
        } else if(user.status === UserStatus.STARTED) {
          if(user.reportDeathWaitSet) {
            this.router.navigate(['/signin/welcome']);
          } else if(user.contactAddress) {
            this.router.navigate(['/signin/reportingWaitPeriod']);
          } else if(user.first_name){
            this.router.navigate(['/signin/address']);
          } else {
            this.router.navigate(['/signin/personal']);
          }
        } else {
          this.userService.user.tfaSuccess = false;
          this.router.navigate(['/dashboard/vault-open']);
        }
      }
    } else {
      this.errorManager.showError(this.errorManager.ERRORS.login_again);
      this.router.navigate(['/signin']);
    }
  }

  async navigateContactToRightScreen() {
    const contact = this.userService.user;
    let termsId;
    await this.requestLastTerms().then((res) => {
      termsId = res.data[0].id;
    });
    if (!contact.termsAccepted || contact.termsId < termsId) {
      this.router.navigate(['/terms']);
    } else if (!contact.tFAPhoneVerified) {
      this.router.navigate(['/contact-phone-verify']);
    } else {
      this.router.navigate(['/dashboard/vault-close']);
    }
  }

  headers = new HttpHeaders().set('Content-Type', 'application/json');
  currentUser = {};

  // Sign-up
  signUp(user): Observable<any> {
    let api = `/register-user`;
    return this.http.post(api, user).pipe(catchError(this.handleError));
  }

  // Sign-in
  signInUser(reqparams) {
    return this.http.post<any>(`/api/signin-user`, reqparams).subscribe(
      (res: any) => {
        //  localStorage.setItem('access_token', res.jwt);
        this.userService.user = res.user;
        this.userService.usertype = this.userService.user.usertype;
        this.navigateUserToRightScreen();
      },
      (err) => {
        console.log('errorrr cominmggg');
        this.router.navigate(['login']);
      }
    );
  }

  signInContact(reqparams) {
    return this.http.post<any>(`/api/signin-contact`, reqparams).subscribe(
      (res: any) => {
        //  localStorage.setItem('access_token', res.jwt);
        this.userService.user = res.user;
        this.userService.usertype = this.userService.user.usertype;
        this.navigateContactToRightScreen();
      },
      (err) => {
        console.log('errorrr cominmggg');
        this.router.navigate(['login']);
      }
    );
  }

  signInAdmin(reqparams) {
    return this.http.post<any>(`/api/admin/signin-admin`, reqparams).subscribe(
      (res: any) => {
        this.userService.user = res.user;
        this.userService.usertype = this.userService.user.usertype;
        this.router.navigate(['admin']);
      },
      (err) => {
        console.log('errorrr cominmggg');
        this.router.navigate(['login']);
      }
    );
  }

  reportFalseDeath(reqparams): Observable<any> {
    return this.http.post<any>(`/api/report-false-death`, reqparams);
  }

  activateContact(reqparams) {
    return this.http.post<any>(`/api/activate-contact`, reqparams).subscribe(
      (res: any) => {
        //  localStorage.setItem('access_token', res.jwt);
        this.userService.user = res.user;
        this.userService.usertype = this.userService.user.usertype;
        this.navigateContactToRightScreen();
      },
      (err) => {
        this.router.navigate(['login']);
      }
    );
  }

  doLogout(isFrozen?) {
    return this.http.post<any>('/api/logout', {}).subscribe((data) => {
      this.userService.user = null;
      this.matDialog.closeAll();
      this.errorManager.clearLastError();
      if (isFrozen) {
        this.router.navigate(['login'], { queryParams: { frozen: true } });
      } else {
        this.router.navigate(['login']);
      }
    });
  }

  cleanUpForLogin() {
    if(this.userService.user){
      this.userService.user.tfaSuccess = false;
      this.userService.user = null;
    }
    this.errorManager.clearLastError();
    this.matDialog.closeAll();
  }

  getUserProfile() {
    if (this.userService.user) {
      return this.userService.user;
    } else {
      this.errorManager.showError(this.errorManager.ERRORS.login_again, MessageTitle.ERROR);
    }
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
}
